module.exports = new __parcel__URL__("chat.ad58c92b.svg").toString();